module.exports = __webpack_public_path__ + "img/2_89.1e240af4.png";